// removed by extract-text-webpack-plugin
module.exports = {"cookieBanner":"styles__cookieBanner__3umBs","button":"styles__button__erQnp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CookieBanner/styles.less
// module id = 176
// module chunks = 0